module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3QWfumjhWUAUAqCgEUCS44-b6dc60aa3325c4a89759fbf896a1be57.jpg";